import { __decorate, __metadata } from 'tslib';
import { NgModule, ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { CommonModule } from '@pwc/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
let I18nModule = class I18nModule {
};
I18nModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: I18nModule });
I18nModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function I18nModule_Factory(t) { return new (t || I18nModule)(); }, imports: [[
            CommonModule,
            TranslateModule.forChild()
        ]] });

let I18nService = class I18nService {
    constructor(translate) {
        this.translate = translate;
        this.langSubject = new BehaviorSubject("IT" /* IT */);
        this.lang$ = this.langSubject.asObservable();
    }
    getValue(key, params) {
        return this.translate.instant(key, params);
    }
    get(key, params) {
        return this.translate.get(key, params);
    }
    setLang(lang) {
        this.langSubject.next(lang);
    }
};
I18nService.ɵfac = function I18nService_Factory(t) { return new (t || I18nService)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService)); };
I18nService.ctorParameters = () => [
    { type: TranslateService }
];
I18nService.ɵprov = ɵɵdefineInjectable({ factory: function I18nService_Factory() { return new I18nService(ɵɵinject(TranslateService)); }, token: I18nService, providedIn: "root" });
I18nService = __decorate([ __metadata("design:paramtypes", [TranslateService])
], I18nService);
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(I18nModule, { imports: function () { return [CommonModule, ɵngcc1.TranslateModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(I18nModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule,
                    TranslateModule.forChild()
                ],
                exports: []
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(I18nService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }]; }, null); })();

class Language {
    constructor(id, code, description) {
        this.id = id;
        this.code = code;
        this.description = description;
    }
}

function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}

function getTranslationField(object, field, lang) {
    if (object.translation == null) {
        return null;
    }
    if (object.translation[lang] == null) {
        return null;
    }
    return object.translation[lang][field];
}

/*
 * Public API Surface of i18n
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HttpLoaderFactory, I18nModule, I18nService, Language, getTranslationField };

//# sourceMappingURL=pwc-i18n.js.map